import React, { useEffect, useState } from "react";
import {
  FaClipboardList,
  FaHome,
  FaBell,
  
  FaUserAlt,
  FaUserCheck,
} from "react-icons/fa";
import {
  MdInbox,
} from "react-icons/md";
import "./Sidebar.css";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";
import { History } from "@mui/icons-material";
import axios from "axios";
import { FaMessage } from "react-icons/fa6";

const Sidebar = ({ darkMode, toggleDarkMode, collapsed }) => {
  const location = useLocation();
  const [unreadCount, setUnreadCount] = useState(0);
  const [formCounts, setFormCounts] = useState({ expired: 0, active: 0 });
  const [chatUnreadCount, setChatUnreadCount] = useState(0); // New state for chat unread count

  const [, setLoading] = useState(true);

  

  const fetchUnreadCount = async () => {
    try {
      setLoading(true);

      // 1. Get current user info
      const meResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/users/me`,
        { withCredentials: true }
      );

      if (!meResponse.data?.success || !meResponse.data.userId) {
        throw new Error("Failed to get user details");
      }

      // 2. Get CSO info
      const csoResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/cso/${meResponse.data.userId}`,
        { withCredentials: true }
      );

      if (!csoResponse.data?.id) {
        throw new Error("CSO information not found");
      }

      // 3. Get unread count for this CSO
      const countResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/letters/cso/${csoResponse.data.id}/unread-count`,
        { withCredentials: true }
      );

      if (countResponse.data?.success) {
        setUnreadCount(countResponse.data.data.unreadCount || 0);
      }
    } catch (error) {
      console.error("Error fetching unread count:", error);
      setUnreadCount(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUnreadCount();

    // Refresh every 5 minutes
    const interval = setInterval(fetchUnreadCount, 300000);
    return () => clearInterval(interval);
  }, []);

  const isActive = (path) => location.pathname === path;

  useEffect(() => {
    const fetchFormCounts = async () => {
      try {
        const meResponse = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/users/me`,
          { withCredentials: true }
        );

        if (!meResponse.data?.success || !meResponse.data.userId) {
          throw new Error("Failed to get user details");
        }
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/form/counts/all`,
          { withCredentials: true }
        );
        setFormCounts(response.data);
      } catch (error) {
        console.error("Error fetching form counts:", error);
      }
    };

    fetchFormCounts();
  }, []);


    const fetchChatUnreadCount = async () => {
    try {
      // Get current user info
      const meResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/users/me`,
        { withCredentials: true }
      );

      if (!meResponse.data?.success || !meResponse.data.userId) {
        throw new Error("Failed to get user details");
      }

      // Get CSO info
      const csoResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/cso/${meResponse.data.userId}`,
        { withCredentials: true }
      );

      if (!csoResponse.data?.id) {
        throw new Error("CSO information not found");
      }

      // Get unread chat messages count for this CSO (messages sent by staff)
      const chatCountResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/chat/${csoResponse.data.id}/unread-count`,
        { withCredentials: true }
      );

      if (chatCountResponse.data?.success) {
        setChatUnreadCount(chatCountResponse.data.unreadCount || 0);
      } else if (chatCountResponse.data?.unreadCount !== undefined) {
        // Handle different response format
        setChatUnreadCount(chatCountResponse.data.unreadCount || 0);
      }
    } catch (error) {
      console.error("Error fetching chat unread count:", error);
      setChatUnreadCount(0);
    }
  };

  useEffect(() => {
    fetchUnreadCount();
    fetchChatUnreadCount(); // Fetch chat unread count

    // Refresh every 5 minutes
    const interval = setInterval(() => {
      fetchUnreadCount();
      fetchChatUnreadCount();
    }, 300000);
    
    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className={`user_sidebar ${collapsed ? "collapsed" : ""} ${
        darkMode ? "dark" : "light"
      }`}
    >
      <div className="logo">
        <h2>{collapsed ? "CSO" : "CSOs"}</h2>
      </div>
      <div className="scrollable-menu">
        <ul className="menu">
          <li
            className={`menu-item ${
              isActive("/user/dashboard") ? "active" : ""
            }`}
          >
            <Link to="/user/dashboard" className="flex items-center">
              <FaHome />
              <span>{!collapsed && "Dashboard"}</span>
            </Link>
          </li>

          <li
            className={`submenu-item ${
              isActive("/user/requests") ? "active" : ""
            }`}
          >
            <Link to="/user/requests" className="flex items-center">
              <FaClipboardList />
              <span> {!collapsed && "Request"}</span>
            </Link>
          </li>
          <li
            className={`menu-item ${
              isActive("/user/letters_list") ? "active" : ""
            }`}
          >
            <Link
              to="/user/letters_list"
              className="inline-flex items-center hover:no-underline whitespace-nowrap"
            >
              <MdInbox className="text-lg" />

              <div className="relative inline-flex">
                {!collapsed && <span className="inline-block">Letter</span>}
                {unreadCount > 0 && (
                  <span className="absolute -top-0 -right-5 bg-red-500 text-white text-[10px] font-bold rounded-full h-4 w-4 flex items-center justify-center">
                    {unreadCount}
                  </span>
                )}
              </div>
            </Link>
          </li>

          <li className={`menu-item ${isActive("/user/form") ? "active" : ""}`}>
            <Link to="/user/form" className="flex items-center">
              <FaUserAlt />
              <span>{!collapsed && "Form"}</span>
              {/* Add notification badge here */}
              {formCounts &&
                // (formCounts.expired > 0 || formCounts.active > 0) && (

                formCounts.active > 0 && (
                  <span
                    className={`ml-2 text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center ${
                      formCounts.expired > 0
                        ? "bg-red-500 text-white"
                        : "bg-green-500 text-white"
                    }`}
                  >
                    {formCounts.expired > 0
                      ? formCounts.expired
                      : formCounts.active}
                  </span>
                )}
            </Link>
          </li>

          <li
            className={`menu-item ${
              isActive("/user/submitted") ? "active" : ""
            }`}
          >
            <Link to="/user/submitted" className="flex items-center">
              <History />
              <span>{!collapsed && "History"}</span>
            </Link>
          </li>
          <li className={`menu-item ${isActive("/user/chat") ? "active" : ""}`}>
            <Link to="/user/chat" className="flex items-center">
              <FaMessage />
              <span>{!collapsed && "Chat"}</span>
              {/* Add notification badge for unread chat messages */}
              {chatUnreadCount > 0 && (
                <span className="ml-2 bg-red-500 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
                  {chatUnreadCount}
                </span>
              )}
            </Link>
          </li>
          <li
            className={`menu-item ${
              isActive("/user/beneficiary_trace") ? "active" : ""
            }`}
          >
            <Link to="/user/beneficiary_trace" className="flex items-center">
              <FaUserCheck />
              <span>{!collapsed && "My Beneficiary"}</span>
            </Link>
          </li>
          <li
            className={`menu-item ${
              isActive("/user/notifications") ? "active" : ""
            }`}
          >
            <Link to="/user/notifications" className="flex items-center">
              <FaBell />
              <span className="ml-2">{!collapsed && "Notifications"}</span>
            </Link>
          </li>

          {/* <li className="menu-item">
            <FaCog />
            <span>{!collapsed && "Settings"}</span>
          </li> */}
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
